export default __webpack_public_path__ + "static/media/2111.4c6e27fc.png";